// Old style (won't work in React 19+)
// import ReactDOM from 'react-dom';

import React from "react";
import ReactDOM from "react-dom/client";
import ChatWidget from "./ChatWidget";

export function render(selector: string, props?: Record<string, unknown>) {
  const el = typeof selector === "string" ? document.querySelector(selector)! : (selector as Element);
  const root = ReactDOM.createRoot(el);
  root.render(React.createElement(ChatWidget, { ...props } as any));
  return () => root.unmount();
}